import { StatusBar } from 'expo-status-bar';
import React from 'react';
import { Platform, StyleSheet, Text } from 'react-native';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import { SafeAreaProvider, SafeAreaView } from 'react-native-safe-area-context';
import * as serviceWorkerRegistration from "./src/serviceWorkerRegistration";
import { ReactNotifications } from 'react-notifications-component'
import AppNavigator from './src/components/AppNavigator';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Game  from './src/components/Game';
import { Storage } from '@capacitor/storage';
import { ThemeProvider } from './src/themes/ThemeContext';



export default function App() {
  return (
    <ThemeProvider>
      <ReactNotifications />
      <BrowserRouter>
      <Routes>
        <Route path="/" element={<AppNavigator />}>
          {/* <Route index element={<Home />} />
          <Route path="blogs" element={<Blogs />} />
          <Route path="contact" element={<Contact />} />
          <Route path="*" element={<NoPage />} /> */}
          <Route path="/board?gm=:gm" element={<Game />}></Route>
          <Route path="*" element={<AppNavigator />}></Route>
        </Route>
      </Routes>
    </BrowserRouter>
    </ThemeProvider>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

serviceWorkerRegistration.register();
